// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Fi","image":"Gi","imageNoBackground":"Hi"};